<template>
  <b-container>
    <b-row class="mt-5 justify-content-center">
      <p class="mb-0 text-center h-emphasis" style="font-weight:900;font-size:1.7em">
        Votre {{ items[currentPage - 1].securities[0].platform_contract.contract.name }} sur
        <span style="text-transform: capitalize">{{ items[currentPage - 1].securities[0].platform_contract.platform.name }}</span>
      </p>
    </b-row>
    <form
      method="POST"
      :action="route"
      id="scannerCardItemsContainer"
      @submit="checkForm"
    >
      <input type="hidden" name="_token" :value="token" />
      <input type="hidden" name="securities" :value="securities_json">
      <div id="CardItemsContainer">
          <p> {{contractSecuritiesLeft}} titres à optimiser </p>
      </div>
      <div id="CardItemsContainer" v-if="isContractKept(items[currentPage - 1])">
        <div v-for="(o, i) in items[currentPage - 1].securities" :key="i" class="mt-5">
          <card-items :item="o" :index="i" :addSecurity="addSecurity" :addAlternative="addAlternative" :addAlternativeESG="addAlternativeESG"/>
        </div>
      </div>
      <div v-else>
        <div class="mb-0 text-center h-emphasis" style="font-weight:500;font-size:1.2em">
            <div class="title">Cette enveloppe est optimisée</div>
        </div>
      </div>
      <b-row class="mt-4 p-3">
          <b-pagination @input="countSecuritiesLeft()" v-model="currentPage" class="pagination_optimiseurPage" :total-rows="rows" :per-page="perPage" prev-text="Enveloppe Précédente" next-text="Enveloppe Suivante" first-number last-number></b-pagination>
        </b-row>
      <b-row style="justify-content:center" class="mt-3">
        <b-button type="submit" class="optimiseurPageFinalBtn" :disabled="!valid">
          Valider mon portefeuille
        </b-button>
      </b-row>
    </form>
  </b-container>
</template>
<script>
import CardItems from "./comps/CardItems.vue";
import TitleAndSubtitle from "./comps/TitleAndSubtitle.vue";
// import data from "./selected_etfs.json";

export default {
  props: ["comparisons_platforms", "token", "route"],
  components: { TitleAndSubtitle, CardItems },
  data() {
    return {
      items: this.comparisons_platforms,
      itemsLength: Object.keys(this.comparisons_platforms).length,
      // pagination
      perPage: 1,
      currentPage: 1,
      rows: Object.keys(this.comparisons_platforms).length,
      valid: false,
      keptSecurities: [],
      securities_json: "",
      contractSecuritiesLeft: 0,
      securitiesLeft: 0,
    };
  },
  mounted()
  {
    this.countSecuritiesLeft();
  },
  methods: {
    isContractKept(item)
    {
      let isTraded = true;
      item.securities.forEach(security => {
        if(security.has_traded == 0)
        {
          isTraded = false;
          return;
        }
      });

      if((item.has_comparison) > 0 && (!isTraded))
      {
        return true;
      }
      else
      {
        return false;
      }
    },
    countSecuritiesLeft()
    {
      this.securitiesLeft = 0

      this.comparisons_platforms.forEach(contract => {
        this.securitiesLeft += this.countContractSecuritiesLeft(contract);
      });
      this.contractSecuritiesLeft = this.countContractSecuritiesLeft(this.comparisons_platforms[this.currentPage-1]);
      if(this.securitiesLeft == 0)
      {
        this.valid = true;
      }
    },
    countContractSecuritiesLeft(contract)
    {
      let contractSecuritiesLeft = 0
      contract.securities.forEach(security => {
        if(security.has_traded == 0)
        {
          if(security.has_traded == 0 && (security.alternatives.length > 0 || security.alternatives_ESG.length > 0))
          {
            contractSecuritiesLeft += 1;
          }
        }
      });
      return contractSecuritiesLeft;
    },
    addSecurity(item)
    {
      var security = item.security;
      security.amount = item.amount;
      security.platform_contract = item.platform_contract;

      if(-1 == this.keptSecurities.indexOf(security))
      {
        item.has_traded = 1;
        this.keptSecurities.push(security);
      }
      this.countSecuritiesLeft();
    },
    addAlternative(item,o)
    {
      var security = o;
      security.amount = item.amount;
      security.platform_contract = item.platform_contract;

      if(-1 == this.keptSecurities.indexOf(security))
      {
        item.has_traded = 1;
        this.keptSecurities.push(security);
      }
      this.countSecuritiesLeft();
    },
    addAlternativeESG(item,o)
    {
      var security = o;
      security.amount = item.amount;
      security.platform_contract = item.platform_contract;

      if(-1 == this.keptSecurities.indexOf(security))
      {
        item.has_traded = 1;
        this.keptSecurities.push(security);
      }
      this.countSecuritiesLeft();
    },
    checkForm(event)
    {
      this.securities_json = JSON.stringify(this.keptSecurities);
    }
  },
};
</script>
<style lang="scss">
@import "./resources/sass/_variables.scss";

.optimiseurPageFinalBtn {
  background: $purple_color 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 41px;
  opacity: 1;
  width: 35%;
}

.pagination_optimiseurPage {
  justify-content: space-between;
  height: 50px;
  background: #121212;
  border-radius: 33px;
  align-items: center;
  width: 100%;

  .page-link {
    margin: 5px;
    background-color: transparent;
    border: none;
    color: $lt_grey_color;
    &:hover {
      background-color: transparent;
      color: $mf_ft_color_white;
    }
  }

  .page-item.active .page-link {
    font-weight: bold;
    background-color: #242527;
    border-radius: 33px;
    color: $vstr_grey_color !important;
  }

  .page-item.disabled .page-link {
    color: #4f4f4f;
    pointer-events: none;
    background-color: #121212;
    border-color: #121212;
  }
}
</style>
